import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import { getMangaBySlug } from '@/mocks/manga';

const MOCK_PAGES = [
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20teenage%20boy%20character%20waking%20up%20in%20bedroom%2C%20morning%20scene%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20teenage%20boy%20walking%20to%20school%20under%20cherry%20blossom%20trees%2C%20outdoor%20scene%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20classroom%20scene%20with%20students%20chatting%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20two%20teenage%20characters%20having%20conversation%20on%20rooftop%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20emotional%20close%20up%20scene%2C%20character%20blushing%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20sunset%20scene%20by%20the%20river%2C%20two%20characters%20walking%20together%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-06&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20dramatic%20confrontation%20scene%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-07&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20festival%20scene%20with%20fireworks%20at%20night%2C%20characters%20watching%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-08&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20emotional%20farewell%20scene%20at%20train%20station%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-09&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%20in%20Chinese%20style%2C%20detailed%20line%20art%2C%20hopeful%20ending%20scene%20with%20smiling%20character%2C%20screentone%20textures%2C%20speech%20bubbles%2C%20clean%20manga%20panel%20layout&width=900&height=1300&seq=chapter-page-10&orientation=portrait',
];

export default function ChapterPage() {
  const { slug, chapterId } = useParams<{ slug: string; chapterId: string }>();
  const manga = getMangaBySlug(slug || '');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!manga) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <i className="ri-error-warning-line text-5xl text-foreground-300 mb-4 block"></i>
            <h1 className="text-2xl font-bold text-foreground-900 mb-2">漫画未找到</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 transition-colors">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const chapter = manga.chapters.find(ch => ch.id === chapterId);
  if (!chapter) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-900 mb-2">章节未找到</h1>
            <Link to={`/manga/${manga.slug}`} className="text-primary-600 hover:text-primary-700 transition-colors">返回漫画详情</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const currentIndex = manga.chapters.findIndex(ch => ch.id === chapterId);
  const prevChapter = currentIndex > 0 ? manga.chapters[currentIndex - 1] : null;
  const nextChapter = currentIndex < manga.chapters.length - 1 ? manga.chapters[currentIndex + 1] : null;

  const pageTitle = `${manga.title} ${chapter.title}-漫画全集下拉式免费阅读-土豪漫画网`;
  const pageDesc = `${manga.title} ${chapter.title}，土豪漫画网提供漫画全集下拉式免费阅读服务。下拉浏览完整章节内容，畅享中文漫画在线阅读体验。`;
  const pageKeywords = `${manga.title},${chapter.title},漫画全集下拉式免费阅读,土豪漫画网`;

  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: manga.title, path: `/manga/${manga.slug}` },
    { label: chapter.title },
  ];

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://i2p1d.com/" },
      { "@type": "ListItem", "position": 2, "name": manga.title, "item": `http://i2p1d.com/manga/${manga.slug}` },
      { "@type": "ListItem", "position": 3, "name": chapter.title },
    ]
  };

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": `${manga.title} - ${chapter.title}`,
    "description": `${manga.title} ${chapter.title}，土豪漫画网提供漫画全集下拉式免费阅读服务。`,
    "author": { "@type": "Person", "name": manga.author },
    "datePublished": chapter.updateTime,
    "dateModified": manga.updateTime,
    "image": manga.cover,
    "publisher": { "@type": "Organization", "name": "土豪漫画网" },
    "isPartOf": { "@type": "Article", "name": manga.title, "url": `http://i2p1d.com/manga/${manga.slug}` }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": pageTitle,
    "description": pageDesc,
    "url": `http://i2p1d.com/manga/${slug}/chapter/${chapterId}`,
    "isPartOf": { "@type": "WebSite", "name": "土豪漫画网", "url": "http://i2p1d.com/" },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://i2p1d.com/" },
        { "@type": "ListItem", "position": 2, "name": manga.title, "item": `http://i2p1d.com/manga/${manga.slug}` },
        { "@type": "ListItem", "position": 3, "name": chapter.title },
      ]
    }
  };

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl={`http://i2p1d.com/manga/${slug}/chapter/${chapterId}`}
        ogTitle={pageTitle}
        ogDescription={pageDesc}
        ogImage={manga.cover}
        ogType="article"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />

      <Navbar />

      <main className="pt-16">
        <div className={`sticky top-16 z-40 transition-colors ${
          isScrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-background-100'
        }`}>
          <div className="max-w-4xl mx-auto px-4 md:px-6 py-3">
            <Breadcrumb items={breadcrumbItems} />
            <div className="flex items-center justify-between mt-1">
              <h1 className="text-sm md:text-base font-bold text-foreground-900 truncate">
                {manga.title} - {chapter.title}
              </h1>
              <div className="flex items-center gap-2 flex-shrink-0">
                {prevChapter ? (
                  <Link
                    to={`/manga/${manga.slug}/chapter/${prevChapter.id}`}
                    className="text-xs bg-background-200 hover:bg-background-300 text-foreground-700 px-3 py-1.5 rounded-full whitespace-nowrap cursor-pointer transition-colors"
                  >
                    <i className="ri-arrow-left-line mr-1"></i>上一话
                  </Link>
                ) : (
                  <span className="text-xs bg-background-100 text-foreground-400 px-3 py-1.5 rounded-full whitespace-nowrap cursor-not-allowed">
                    <i className="ri-arrow-left-line mr-1"></i>上一话
                  </span>
                )}
                {nextChapter ? (
                  <Link
                    to={`/manga/${manga.slug}/chapter/${nextChapter.id}`}
                    className="text-xs bg-primary-500 hover:bg-primary-600 text-white px-3 py-1.5 rounded-full whitespace-nowrap cursor-pointer transition-colors"
                  >
                    下一话<i className="ri-arrow-right-line ml-1"></i>
                  </Link>
                ) : (
                  <span className="text-xs bg-background-100 text-foreground-400 px-3 py-1.5 rounded-full whitespace-nowrap cursor-not-allowed">
                    下一话<i className="ri-arrow-right-line ml-1"></i>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="bg-background-200">
          <div className="max-w-2xl mx-auto">
            {MOCK_PAGES.map((pageUrl, idx) => (
              <div key={idx} className="w-full">
                <img
                  src={pageUrl}
                  alt={`${manga.title} ${chapter.title} 第${idx + 1}页`}
                  title={`${manga.title} ${chapter.title} 第${idx + 1}页`}
                  className="w-full h-auto block"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="bg-background-50 py-8">
          <div className="max-w-4xl mx-auto px-4 md:px-6 flex items-center justify-between">
            <div>
              {prevChapter ? (
                <Link
                  to={`/manga/${manga.slug}/chapter/${prevChapter.id}`}
                  className="inline-flex items-center gap-2 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer transition-colors"
                >
                  <i className="ri-arrow-left-line"></i>
                  上一话：{prevChapter.title}
                </Link>
              ) : (
                <span></span>
              )}
            </div>
            <Link
              to={`/manga/${manga.slug}`}
              className="text-foreground-500 hover:text-primary-600 text-sm transition-colors whitespace-nowrap"
            >
              <i className="ri-list-check mr-1"></i>章节列表
            </Link>
            <div>
              {nextChapter ? (
                <Link
                  to={`/manga/${manga.slug}/chapter/${nextChapter.id}`}
                  className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer transition-colors"
                >
                  下一话：{nextChapter.title}
                  <i className="ri-arrow-right-line"></i>
                </Link>
              ) : (
                <span className="inline-flex items-center gap-2 bg-background-100 text-foreground-400 font-medium px-5 py-2.5 rounded-full whitespace-nowrap cursor-not-allowed">
                  已经是最后一话了
                </span>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}